export default {
  'pet-profile:page:title': 'My Profile',
  'pet-profile:header:title': '<p>A</p> <p>Personal</p> <p>Selection</p>',
  'pet-profile:display:not-chosen': 'Not chosen',
  'pet-profile:display:breed-not-chosen': '+ Add breed',
  'pet-profile:display:weight-not-chosen': '+ Add weight',
  'pet-profile:display:age-not-chosen': '+ Add age',
  'pet-profile:display:needs-not-chosen': '+ Add need',
  'pet-profile:display:food-type-not-chosen': '+ Add food type',
  'pet-profile:display:your-pet': 'For your dog',
  'pet-profile:display:edit': 'Edit',
  'pet-profile:display:edit-your-pet-profile': 'Edit your personal profile',
  'pet-profile:display:edit-your-pet-profile:title:empty': 'Create a profile for your pet',
  'pet-profile:display:edit-your-pet-profile:title:filled': 'Edit profile',
  'pet-profile:display:edit-your-pet-profile:subtitle':
    'For targeted product recommendations that really fit!',
  'pet-profile:display:food-preference': 'Food preference',
  'pet-profile:cdp:title': 'Wow! Recommendations - tailored to your needs',
  'pet-profile:cdp:title:cat': 'Recommendations for Your Cat',
  'pet-profile:no-petprofile-page:title': 'Individual product recommendation in 3, 2, 1 …!',
  'pet-profile:no-petprofile-page:text': `Tell us the age, breed and special needs of your favorite and receive a personal product selection from us. {br}
        {br}
        Have you already ordered from us? Then log in to your existing account.`,
  'pet-profile:no-petprofile-page:start': 'Create food recommendation',
  'pet-profile:no-petprofile-page:login': 'Log in now',
  'pet-profile:header:your-pet': 'Your pet',
  'pet-profile:header:add-profile': 'Create another profile',
  'pet-profile:placeholder:dog-name': 'Your pet',
  'pet-profile:segmentation-update-sheet:weight-error': 'Weight must be between {min} and {max} kg',
  'pet-profile:segmentation-update-sheet:name:placeholder': 'Enter name',
  'pet-profile:guide-change-pet-description': 'Here you can switch between your profiles',
  'pet-profile:guide-edit-description': 'For a better experience – give your pet a name!',
  'pet-profile:segmentation-update-sheet:delete-profile:button': 'Delete this profile',
  'pet-profile:segmentation-update-sheet:delete-profile:title': 'Are you sure?',
  'pet-profile:segmentation-update-sheet:delete-profile:text:with-pet-name':
    "Are you sure you want to delete {petName}'s profile? This action cannot be undone.",
  'pet-profile:segmentation-update-sheet:delete-profile:text:without-pet-name':
    'Are you sure you want to delete your personal profile? This action cannot be undone.',
  'pet-profile:segmentation-update-sheet:delete-profile:confirm': 'Yes, delete',
  'pet-profile:segmentation-update-sheet:delete-profile:cancel': 'Cancel',
  'pet-profile:error:duplicate-name': 'You already have an existing profile with this name.',
  'pet-profile:error:name-required': 'Please enter a name.',

  'pet-profile:feed-type-selector:title': 'Food Type & Consistency',
  'pet-profile:feed-type-selector:wet_food': 'Wet Food',
  'pet-profile:feed-type-selector:dry_food': 'Dry Food',
  'pet-profile:feed-type-selector:snacks': 'Snacks',
  'pet-profile:feed-type-selector:barf': 'BARF',
  'pet-profile:feed-type-selector:wet_food:sauce': 'Sauce',
  'pet-profile:feed-type-selector:wet_food:pate': 'Pate',
  'pet-profile:feed-type-selector:wet_food:cream': 'Cream',
  'pet-profile:feed-type-selector:wet_food:description:sauce': 'Sauce Menu, Juicy Filet',
  'pet-profile:feed-type-selector:wet_food:description:pate': 'Pure Meat, Filet Menu, Meaty Pate',
  'pet-profile:feed-type-selector:wet_food:description:cream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency-title': 'Consistency',
  'pet-profile:feed-type-selector:consistency:sauce': 'Sauces',
  'pet-profile:feed-type-selector:consistency:pate': 'Pate',
  'pet-profile:feed-type-selector:consistency:cream': 'Cream',
  'pet-profile:feed-type-selector:consistency:sauce:saucen-menu': 'Sauce Menu',
  'pet-profile:feed-type-selector:consistency:sauce:juicyfilets': 'Juicy Filet',
  'pet-profile:feed-type-selector:consistency:pate:puremeat': 'Pure Meat',
  'pet-profile:feed-type-selector:consistency:pate:filet-menu': 'Filet Menu',
  'pet-profile:feed-type-selector:consistency:pate:meatypate': 'Meaty Pate',
  'pet-profile:feed-type-selector:consistency:cream:silkycream': 'Silky Cream',
  'pet-profile:feed-type-selector:consistency:all': 'All Consistencies',

  'pet-profile:taste-selector:title': 'Preferred Taste',
  'pet-profile:taste-selector:description': 'Choose the taste that your cat likes best',
  'pet-profile:protein-preference-selector:title': 'Flavours',
  'pet-profile:protein-preference-selector:description':
    'Tell us whether your cat likes, dislikes, or feels neutral about each flavour.',
  'pet-profile:protein-preference-selector:state:dislike': 'Dislike',
  'pet-profile:protein-preference-selector:state:neutral': 'Neutral',
  'pet-profile:protein-preference-selector:state:like': 'Like',
  'pet-profile:protein-preference-selector:choice:dislike': 'Dislike',
  'pet-profile:protein-preference-selector:choice:neutral': 'Neutral',
  'pet-profile:protein-preference-selector:choice:like': 'Like',
  'pet-profile:no-pet-profile:title:dog': "Looking for your dog's profile?",
  'pet-profile:no-pet-profile:title:cat': "Looking for your cat's profile?",
  'pet-profile:no-pet-profile:title:name': "Looking for {name}'s profile?",

  'pet-profile:snack-slider:headline:with-name': 'Perfect addition for {name}',
  'pet-profile:snack-slider:headline:with-breed': 'Perfect addition for {breed}',
  'pet-profile:snack-slider:headline:with-pet-type':
    'Perfect addition for your {petType, select, cat {cat} other {dog}}',
  'pet-profile:empty-collection:title': 'No matching products available',
  'pet-profile:empty-collection:description':
    'Please reduce the number of selected filters to see products.',
  'pet-profile:empty-collection:image-alt': 'No matching products found',

  'pet-profile:empty-profile:title': "Food that's truly tailored",
  'pet-profile:empty-profile:description':
    "Create a profile for your dog or cat. Based on their age, breed and needs, we'll recommend food that's right for them.",
  'pet-profile:empty-profile:cta': 'Create profile',
  'pet-profile:empty-profile:image-alt': 'Dog and cat with a food bowl',

  'pet-profile:calorie-calculator:title': 'Calorie Calculator',
  'pet-profile:calorie-calculator:subtitle':
    'Calculate the optimal daily food amount for your pet in one minute',
  'pet-profile:calorie-calculator:product-page-hint':
    'We calculate how long the food lasts on the product page. Simply adjust the variant and quantity.',
  'pet-profile:calorie-calculator:back-to-product': 'Back to product',
  'pet-profile:calorie-calculator:start-calculation': 'Start calculation',
  'pet-profile:calorie-calculator:requires-support:young-dog':
    'Doggos under 3 months need individual consultation. Please contact our nutrition experts.',
  'pet-profile:calorie-calculator:requires-support:young-cat':
    'Kittens under 7 weeks need individual consultation. Please contact our nutrition experts.',
  'pet-profile:calorie-calculator:requires-support:dog':
    'Doggos with special needs require individual consultation. Please contact our nutrition experts.',
  'pet-profile:calorie-calculator:requires-support:cat':
    'Cats with special needs require individual consultation. Please contact our nutrition experts.',
  'pet-profile:calorie-calculator:kcal-per-day': 'Kcal / day',
  'pet-profile:calorie-calculator:grams-per-day': 'Grams / day',
  'pet-profile:calorie-calculator:consultation':
    'You can arrange individual consultation with our nutrition experts <link>here</link>.',
  'pet-profile:calorie-calculator:next': 'Next',
  'pet-profile:calorie-calculator:yes': 'Yes',
  'pet-profile:calorie-calculator:no': 'No',
  'pet-profile:calorie-calculator:days-per-pack:start': 'Calculate food amount',
  'pet-profile:calorie-calculator:days-per-pack:requires-support':
    'We cannot calculate the daily calorie requirement due to special needs. You can book an individual consultation with our nutrition experts <link>here</link>.',
  'pet-profile:calorie-calculator:days-per-pack:coverage':
    'The selected variant and quantity cover the requirement for <strong>{totalDays} {totalDays, plural, one {day} other {days}}</strong>.',
  'pet-profile:calorie-calculator:wizard:loading':
    'Calculating now - your feeding recommendation in 3, 2, 1...',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:dog': 'When was your doggo born?',
  'pet-profile:calorie-calculator:wizard:date-of-birth:title:cat': 'When was your kitty born?',
  'pet-profile:calorie-calculator:wizard:breed:title': 'Which breed describes your doggo best?',
  'pet-profile:calorie-calculator:wizard:breed:hint':
    'Breed tells us a lot about energy level and metabolism. This helps us find the right amount.',
  'pet-profile:calorie-calculator:wizard:weight:title': 'What is the current weight?',
  'pet-profile:calorie-calculator:wizard:special-needs:title': 'Anything to consider, like...',
  'pet-profile:calorie-calculator:wizard:special-needs:description:dog':
    'Illnesses, pregnancy, lactation, or a recent surgery can affect your dog’s nutritional needs. Does any of this apply to your pet?',
  'pet-profile:calorie-calculator:wizard:special-needs:description:cat':
    'Illnesses, pregnancy, lactation, or a recent surgery can affect your cat’s nutritional needs. Does any of this apply to your cat?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:dog':
    'Is your doggo neutered or sterilized?',
  'pet-profile:calorie-calculator:wizard:sterilized:title:cat':
    'Is your cat neutered or sterilized?',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:dog':
    'After neutering, many dogs use less energy - that is why this step is so important for the calculation.',
  'pet-profile:calorie-calculator:wizard:sterilized:hint:cat':
    'After neutering, many cats use less energy - that is why this step is so important for the calculation.',
  'pet-profile:calorie-calculator:wizard:body-condition:title': 'Time for a body check!',
  'pet-profile:calorie-calculator:wizard:body-condition:description':
    'Pay special attention to waist, ribs, and overall appearance so you can choose the best estimate for your pet.',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:title': 'Very lean',
  'pet-profile:calorie-calculator:wizard:body-condition:very-lean:description':
    'Ribs clearly visible',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:title': 'Slightly too lean',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-lean:description':
    'Waist clearly visible',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:title': 'Ideal shape',
  'pet-profile:calorie-calculator:wizard:body-condition:ideal:description': 'Ribs easy to feel',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:title': 'Slightly rounded',
  'pet-profile:calorie-calculator:wizard:body-condition:slightly-rounded:description':
    'Little waist visible',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:title': 'Well padded',
  'pet-profile:calorie-calculator:wizard:body-condition:well-padded:description':
    'Hanging belly / no waist',
  'pet-profile:calorie-calculator:wizard:activity-level:title:cat': 'How active is your kitty?',
  'pet-profile:calorie-calculator:wizard:activity-level:title:dog': 'How active is your doggo?',
  'pet-profile:calorie-calculator:wizard:activity-level:low:title': 'Indoor / Low',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:cat':
    'For cats with a calm indoor routine. They move little and usually have short, relaxed play sessions.',
  'pet-profile:calorie-calculator:wizard:activity-level:low:description:dog':
    'Up to around 1 hour of relaxed walking per day, plus occasional play (for example at home).',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:title': 'Indoor / Normal',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:cat':
    'For indoor cats with an active daily routine. Regular play, climbing, and movement are part of their day.',
  'pet-profile:calorie-calculator:wizard:activity-level:medium:description:dog':
    'Around 1-2 hours of activity per day, including running, ball games, or similar activities.',
  'pet-profile:calorie-calculator:wizard:activity-level:high:title': 'Outdoor / Active',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:cat':
    'For cats with free outdoor access. They move a lot, explore their territory, and cover longer distances.',
  'pet-profile:calorie-calculator:wizard:activity-level:high:description:dog':
    'More than 2 hours of intensive outdoor activity per day and/or regular hobby sports (for example jogging or agility).',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:cat':
    'We take care of your kitty’s needs',
  'pet-profile:calorie-calculator:wizard:support:title:special-needs:dog':
    'We take care of your dog’s special needs',
  'pet-profile:calorie-calculator:wizard:support:title:young-dog': 'Small dogs, big responsibility',
  'pet-profile:calorie-calculator:wizard:support:title:young-cat':
    'Small kitties, big responsibility',
  'pet-profile:calorie-calculator:wizard:support:description:young-dog':
    "Young puppies grow rapidly and need nutrition tailored specifically to them. That's why we gladly take time for a personal consultation – so your doggo gets the optimal support they need from the very start.",
  'pet-profile:calorie-calculator:wizard:support:description:young-cat':
    "Young kittens grow rapidly and need nutrition tailored specifically to them. That's why we gladly take time for a personal consultation – so your kitty gets the optimal support they need from the very start.",
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:dog':
    'To ensure your dog is optimally cared for, we recommend a personal, free consultation. This lets us create a feeding plan that perfectly matches their individual needs.',
  'pet-profile:calorie-calculator:wizard:support:description:special-needs:cat':
    'To make sure your kitty is optimally cared for, we recommend a personal and free consultation. This lets us create a feeding plan that perfectly matches their individual needs.',
  'pet-profile:calorie-calculator:wizard:support:cta': 'Book free consultation',
  'pet-profile:calorie-calculator:wizard:support:go-back': 'Back to the questions',
  'pet-profile:avatar:image-alt': 'Image of a {petType}',
};
